import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppNavigationService } from '../../services/app-navigation.service';

@Component({
  selector: 'app-view',
  standalone: false,
  templateUrl: './app-view.component.html',
  styleUrls: ['./app-view.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class AppViewComponent implements OnDestroy, OnInit {
  private readonly _appNavigationService = inject(AppNavigationService);

  private subscriptions: Subscription = new Subscription();

  accommodateAppHeader: boolean;
  accommodateAppSidebar: boolean;

  ngOnInit(): void {
    this.subscriptions.add(
      this._appNavigationService.showAppHeader$.subscribe(value => {
        this.accommodateAppHeader = value;
      }),
    );

    this.subscriptions.add(
      this._appNavigationService.showAppSidebar$.subscribe(value => {
        this.accommodateAppSidebar = value;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
